import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';


function pageName(number , language) {

    const pageNames = {
        1: language === 'ar' ? "تطوير مواقع الكترونية" : "Websites development",
        2: language === 'ar' ? "تطوير تطبيقات الموبايل" : "Mobile App Development",
        3: language === 'ar' ? "أنظمة إدارة المحتوى ولوحات التحكم" : "CMS & Admin Panels",
        4: language === 'ar' ? "تحسين محركات البحث" : "SEO Optimisation",
        5: language === 'ar' ? "الصيانة والدعم الفني" : "Maintenance & Support",
    };
    return pageNames[number] || "خدمة غير معروفة";
}


export default function BasicBreadcrumbs({ number }) {
    const { i18n } = useTranslation();

    return (
        <div role="presentation">
            <Breadcrumbs
                aria-label="breadcrumb"
                sx={{
                    color: "white", // لجعل النص أبيض
                    "& .MuiBreadcrumbs-separator": { color: "white" } // لجعل الفواصل بيضاء
                }}
            >
                <Typography color="white">
                    {pageName(Number(number) , i18n.language)}
                </Typography>
                <Link style={{ color: "#ff014f", textDecoration: 'underLine' }} to="/">
                    {i18n.language === 'ar' ? 'الصفحة الرئيسية' : 'home page'}
                </Link>
            </Breadcrumbs>
        </div>
    );
}
